<template>
  <div class="def_juris_btn">
    <template v-if="set_style == 1">
      <el-button :size="set_size" :type="set_type" :disabled="!view_state">
        <slot></slot>
      </el-button>
    </template>
    <template v-else-if="view_state">
      <el-button :size="set_size" :type="set_type">
        <slot></slot>
      </el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: ['juris_key', 'set_style', 'set_size', 'set_type'],
  data() {
    return {
      view_state: false
    }
  },
  created: function () {
    let jurisArr = this.$store.getters.roles;
    for (let i = 0; i < jurisArr.length; i++) {
      if (jurisArr[i]['key'] == this.juris_key) {
        this.view_state = true;
        break;
      }
    }

  }
}
</script>

<style lang="css">
.def_juris_btn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// jurs_btn.vue?e81e9032